import { axios } from 'api'

export type ProductLine = { value: string; label: string }

export const fetchProductLines = async (): Promise<ProductLine[]> => {
  const response = await axios.get('/product-lines')
  return response.data
}
